import styled from "styled-components";
import media from "../../../../styles/media";

const SearchOverlayContainer = styled.div`
  position: fixed;
  top: 80px; /* Below header */
  right: 20px;
  width: 500px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 120px);
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 1301;

  ${media.lessThan("medium")`
    top: 70px;
    right: 10px;
    left: 10px;
    width: auto;
    max-width: none;
  `}

  .search-overlay-header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #e0e0e0;
    background: #f8f9fa;

    h2 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ${media.lessThan("small")`
      padding: 12px 16px 8px;

      h2 {
        font-size: 1rem;
      }
    `}
  }

  .search-overlay-content {
    display: flex;
    flex-direction: column;

    .MuiList-root {
      padding: 0;
    }

    .MuiListItem-root {
      padding: 0;

      .MuiCard-root {
        box-shadow: none;
        background: transparent;

        .MuiCardContent-root {
          padding: 8px 16px !important;
        }
      }
    }

    .MuiChip-root {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 0.65rem;
      height: 20px;
    }

    .MuiPagination-root {
      .MuiPaginationItem-root {
        &.Mui-selected {
          background-color: ${(props) => props.theme.color.primary};
          color: white;

          &:hover {
            background-color: ${(props) => props.theme.color.primary}dd;
          }
        }
      }
    }
  }

  /* Scrollbar styling */
  .MuiList-root {
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }
  }
`;

export { SearchOverlayContainer };